import React, { useMemo } from "react";
import Grid from "@mui/material/Grid";
import DeleteForeverRoundedIcon from "@mui/icons-material/DeleteForeverRounded";
import {
  downloadUserServiceFileUsingGET,
  makeDELETERequestOnUserServiceWithQueryParameter,
  makeGETRequestOnUserService,
} from "../../Api/api";
import toastr from "toastr";
import { RouteComponentProps } from "react-router-dom";
import DownloadRoundedIcon from "@mui/icons-material/DownloadRounded";
import { ActionButtons, OrderDetailsInterface } from "../RFQOrders/interfaces";
import { StyledButton } from "../RFQOrders/NewRFQOrderDetails";
import { downloadPDFFile } from "../RFQOrders/DealInfoActionButtons";

const DealSellInfoActionButtons = ({
  orderDetails,
  orderUUID,
  props,
  type,
}: {
  orderDetails: OrderDetailsInterface;
  orderUUID: string;
  props: RouteComponentProps;
  type: string;
}) => {
  const downloadQuoteReceipt = () => {
    let apiUrl = `order_management_v2/client/quote_receipt_download/${orderUUID}/`;
    if (type === "partner") {
      apiUrl += "?user_type=partner";
    } else if (type === "client") {
      apiUrl += "?user_type=client";
    }
    downloadUserServiceFileUsingGET(apiUrl)
      .then((response) => {
        if (response && response.status === 200) {
          downloadPDFFile(
            response.data,
            `Quote Receipt ${orderDetails.buyer_full_name}.pdf`
          );
          toastr.success("Quote Receipt Downloaded Successfully");
        }
      })
      .catch((error) => toastr.error(error));
  };
  const downloadOrdersheet = () => {
    let apiUrl = `/digio/download_client_order_receipt_pdf/${orderDetails?.rfq_deal_id}/order/`;
    if (type === "partner") {
      apiUrl += "?user_type=partner";
    } else if (type === "client") {
      apiUrl += "?user_type=client";
    }
    downloadUserServiceFileUsingGET(apiUrl)
      .then((response) => {
        if (response && response.status === 200) {
          toastr.success("Order Sheet Downloaded Successfully");
          downloadPDFFile(
            response.data,
            `Order_Receipt_${orderDetails?.rfq_deal_id}.pdf`
          );
        }
      })
      .catch((error) => toastr.error(error));
  };
  const downloadDealConfirmation = () => {
    let apiUrl = `/digio/download_client_order_receipt_pdf/${orderDetails?.rfq_deal_id}/deal/`;
    if (type === "partner") {
      apiUrl += "?user_type=partner";
    } else if (type === "client") {
      apiUrl += "?user_type=client";
    }
    downloadUserServiceFileUsingGET(apiUrl)
      .then((response) => {
        if (response && response.status === 200) {
          toastr.success("Deal Sheet Downloaded Successfully");
          downloadPDFFile(
            response.data,
            `Dealsheet_${orderDetails?.rfq_deal_id}.pdf`
          );
        }
      })
      .catch((error) => toastr.error(error));
  };

  const downloadCashflow = () => {
    let apiUrl = `order_management_v2/client/cashflow_download/${orderUUID}/`;
    if (type === "partner") {
      apiUrl += "?user_type=partner";
    } else if (type === "client") {
      apiUrl += "?user_type=client";
    }
    makeGETRequestOnUserService(apiUrl)
      .then((response) => {
        if (response && response.status === 200) {
          downloadPDFFile(
            response.data.pdf_file,
            `Cashflow_${orderDetails?.rfq_deal_id}.pdf`
          );
          toastr.success("Cashflow Downloaded Successfully");
        }
      })
      .catch((error) => {
        toastr.error(error);
      });
  };
  const deleteRFQOrder = () => {
    let apiUrl = `order_management_v2/client/rfq_order_delete/${orderUUID}/`;
    if (type === "partner") {
      apiUrl += "?user_type=partner";
    } else if (type === "client") {
      apiUrl += "?user_type=client";
    }
    makeDELETERequestOnUserServiceWithQueryParameter(apiUrl)
      .then((response) => {
        if (response && response.status === 204) {
          toastr.success("RFQ order deleted successfully");
          setTimeout(() => {
            props.history.push(`/rfq_sell_orders`);
          }, 2000);
        }
      })
      .catch((error) => toastr.error(error));
  };

  const dealInformationActionButtons: ActionButtons[] = useMemo(
    () => [
      {
        name: "Download Quote Receipt",
        color: "secondary",
        icon: <DownloadRoundedIcon />,
        disabled: false,
        handleClick: () => downloadQuoteReceipt(),
      },
      {
        name: "Download Order Receipt",
        color: "secondary",
        icon: <DownloadRoundedIcon />,
        disabled: !orderDetails?.is_added_on_rfq,
        handleClick: () => downloadOrdersheet(),
      },
      {
        name: "Download Deal Confirmation",
        color: "secondary",
        icon: <DownloadRoundedIcon />,
        disabled: !orderDetails?.is_added_on_rfq,
        handleClick: () => downloadDealConfirmation(),
      },
      {
        name: "Download Cashflow",
        color: "secondary",
        icon: <DownloadRoundedIcon />,
        disabled: false,
        handleClick: () => downloadCashflow(),
      },
      JSON.parse(localStorage.getItem("loginUser")!)?.isSuperuser && {
        name: "Delete RFQ Order",
        color: "error",
        icon: <DeleteForeverRoundedIcon />,
        handleClick: () => deleteRFQOrder(),
      },
    ],
    [orderDetails]
  );

  return (
    <Grid container spacing={2} mt={4}>
      {dealInformationActionButtons
        .filter((item) => item.name && item.name.length)
        .map((button, index) => (
          <Grid item key={index} xs={6} sm={4} md={"auto"}>
            <StyledButton
              startIcon={button.icon}
              color={button.color}
              onClick={button.handleClick}
              disabled={button.disabled}
            >
              {button.name}
            </StyledButton>
          </Grid>
        ))}
    </Grid>
  );
};

export default DealSellInfoActionButtons;
